import gignaatiImage1 from "@/assets/image.jpeg";
import gignaatiImage2 from "@/assets/image1.png";
import gksImage1 from "@/assets/image2.png";
import gksImage2 from "@/assets/image3.png";
import clinicFlow from "@/assets/projects/ClinicFlow1.png";
import clinicFlow1 from "@/assets/projects/ClinicFlow2.png";
import clinicFlow2 from "@/assets/projects/ClinicFlow3.png";
import ledgerDesk from "@/assets/projects/LedgerDesk.png";
import ledgerDesk1 from "@/assets/projects/LedgerDesk1.png";
import ledgerDesk2 from "@/assets/projects/LedgerDesk2.png";
import PropTrail from "@/assets/projects/PropTrail.png";
import PropTrail1 from "@/assets/projects/PropTrail.png";

export const projectCategories = [
  "All",
  "Websites",
  "SaaS / Software",
  "CRM & Systems",
  "Automation",
  "SEO",
];

export const projects = [
  {
    slug: "clinicflow-crm",
    name: "ClinicFlow CRM",
    category: "CRM & Systems",
    industry: "Healthcare & Clinics",
    description:
      "Appointment, patient follow-up and reporting system for a multi-doctor clinic.",
    tech: ["React", "Node.js", "MongoDB", "WhatsApp API"],
    image:
      clinicFlow,
    caseStudy: {
      problem:
        "A multi-doctor clinic managing appointments on paper registers and follow-ups over personal WhatsApp numbers. Patient history lived in three different places, and no-shows were untracked.",
      objectives: [
        "One patient record across the front desk and every doctor",
        "Automated appointment reminders and follow-up sequences",
        "A daily operations dashboard for the clinic director",
        "Role-based access for doctors, desk staff and management",
      ],
      solution:
        "A custom clinic CRM connected to the clinic's website booking form. New enquiries flow straight into the pipeline, reminders run automatically, and a dashboard shows today's schedule, pending follow-ups and monthly trends.",
      features: [
        "Patient records & visit history",
        "Appointment pipeline with reminders",
        "Automated follow-up workflows",
        "Doctor-wise schedules",
        "Revenue & visit reports",
        "Role-based access control",
      ],
      architecture: ["Website Form", "Clinic CRM", "Automation Engine", "Database", "Reports Dashboard"],
      screens: [
        clinicFlow1,
        clinicFlow2,
      ],
      results:
        "42% fewer appointment no-shows in the first 90 days, and front-desk reporting time cut from 3 hours a week to 10 minutes.",
    },
  },
  {
    slug: "ledgerdesk",
    name: "LedgerDesk",
    category: "SaaS / Software",
    industry: "CA & Finance",
    description:
      "Client portal and compliance tracking platform for chartered accountant firms.",
    tech: ["React", "FastAPI", "PostgreSQL", "AWS"],
    image:
      ledgerDesk,
    caseStudy: {
      problem:
        "A CA firm chasing documents over email and tracking filing deadlines in spreadsheets. Clients had no visibility, and the team rebuilt the same status report every week.",
      objectives: [
        "A client portal for document upload and status tracking",
        "Automated deadline reminders for recurring compliance work",
        "One dashboard of every client, task and filing status",
        "Replace the weekly manual status report",
      ],
      solution:
        "A custom portal where clients upload documents and see live status, while the internal team works from a task system with automated reminders and one-click client reports.",
      features: [
        "Client portal with document vault",
        "Compliance calendar & reminders",
        "Task and team management",
        "Automated client status reports",
        "Engagement-wise billing view",
        "Audit trail on every document",
      ],
      architecture: ["Client Portal", "Task System", "Reminder Engine", "Database", "Partner Dashboard"],
      screens: [
        ledgerDesk1,
        ledgerDesk2,
      ],
      results:
        "Weekly status reporting fully automated, and document turnaround time down 55% across 120+ active clients.",
    },
  },
  {
    slug: "proptrail",
    name: "PropTrail",
    category: "CRM & Systems",
    industry: "Real Estate",
    description:
      "Lead-to-site-visit pipeline for a premium real estate advisory team.",
    tech: ["React", "Node.js", "MongoDB", "Twilio"],
    image:
      PropTrail,
    caseStudy: {
      problem:
        "Property enquiries arrived from the website, portals and phone calls — and lived in agents' personal phones. Follow-ups depended on memory, and management had no pipeline visibility.",
      objectives: [
        "Capture every enquiry from every source in one place",
        "A pipeline from new lead to site visit to negotiation",
        "Automated follow-up nudges for agents",
        "Weekly source-wise performance reports",
      ],
      solution:
        "A real-estate CRM wired into the website and ad channels. Leads route to agents automatically, follow-ups are scheduled by the system, and management sees the full pipeline live.",
      features: [
        "Multi-source lead capture",
        "Site-visit pipeline stages",
        "Agent assignment rules",
        "Follow-up automation",
        "Property inventory mapping",
        "Source ROI reports",
      ],
      architecture: ["Website & Portals", "Real Estate CRM", "Automation Engine", "Database", "Management Reports"],
      screens: [
        PropTrail1,
        PropTrail,
      ],
      results:
        "Lead response time down from hours to under 2 minutes, with zero enquiries lost in the first quarter.",
    },
  },
  // {
  //   slug: "nova-commerce",
  //   name: "Nova Commerce",
  //   category: "Websites",
  //   industry: "E-commerce",
  //   description:
  //     "Conversion-first storefront rebuild with connected inventory and orders dashboard.",
  //   tech: ["Next.js", "Node.js", "Stripe", "Redis"],
  //   image:
  //     "https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg?auto=compress&cs=tinysrgb&w=1200",
  //   caseStudy: {
  //     problem:
  //       "A premium D2C brand on a slow theme-based store. Pages loaded late on mobile, the checkout leaked buyers, and inventory was reconciled by hand at night.",
  //     objectives: [
  //       "Sub-two-second load times on mobile",
  //       "A redesigned, conversion-focused storefront",
  //       "Live inventory sync between store and warehouse sheet",
  //       "A single orders and revenue dashboard",
  //     ],
  //     solution:
  //       "A custom-built storefront with a connected backend: orders, inventory and customer data flow into one dashboard, and abandoned-cart recovery runs automatically.",
  //     features: [
  //       "Custom storefront & product pages",
  //       "Optimized checkout flow",
  //       "Live inventory sync",
  //       "Abandoned-cart automation",
  //       "Orders & revenue dashboard",
  //       "Core Web Vitals green across pages",
  //     ],
  //     architecture: ["Storefront", "Order System", "Automation Engine", "Inventory Database", "Revenue Dashboard"],
  //     screens: [
  //       "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&w=1200",
  //       "https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg?auto=compress&cs=tinysrgb&w=1200",
  //     ],
  //     results:
  //       "Mobile load time cut from 5.8s to 1.4s, and checkout completion up 31% within 60 days of launch.",
  //   },
  // },
  {
  slug: "gks-design-group",
  name: "GKS Design Group",
  category: "Architecture & BIM",
  industry: "AEC / Architecture / Interior Design",
  description:
    "Architecture, interior design, CAD drafting, BIM modeling, MEP coordination, and design documentation services delivered for hospitality, residential, commercial, retail, industrial, and corporate projects worldwide.",

  tech: [
    "React",
    "Lenis",
    "GSAP",
    "Framer",
  ],

  image:
    gksImage1,

  caseStudy: {
    problem:
      "Architecture and interior design firms need accurate technical documentation, coordinated BIM models, detailed CAD drawings, MEP documentation, and high-quality visualizations while working under demanding project schedules and international standards. Managing all of this documentation in-house can increase production costs, staffing requirements, coordination issues, and turnaround times.",

    objectives: [
      "Provide accurate architectural CAD and Revit documentation",
      "Build coordinated BIM models for complex projects",
      "Support architecture and interior design firms as an extended documentation team",
      "Reduce documentation cost and project turnaround time",
      "Deliver construction-ready drawings with strong quality control",
      "Support hospitality, residential, commercial, retail, industrial, and corporate projects",
      "Provide coordinated MEP documentation and BIM services",
      "Create realistic 3D visualizations for interior and exterior spaces",
      "Maintain international drafting and documentation standards"
    ],

    solution:
      "GKS Design Group and GKS Studio operate as an extended design development and documentation team for architecture, interior design, and construction firms. The service ecosystem combines CAD drafting, Revit/BIM modeling, architectural documentation, MEP coordination, interior design documentation, 3D modeling, rendering, Scan-to-BIM, and advanced BIM dimensions to take projects from concept and design development through construction documentation and lifecycle support.",

    features: [
      "Architectural CAD drafting",
      "2D floor plans, elevations, sections, and details",
      "3D CAD modeling",
      "AutoCAD drafting",
      "Revit BIM modeling",
      "BIM documentation",
      "BIM content creation",
      "Clash detection and coordination",
      "Scan-to-BIM services",
      "3D architectural visualization",
      "Interior and exterior rendering",
      "3D animation and walkthroughs",
      "Interior design documentation",
      "MEP BIM coordination",
      "HVAC BIM coordination",
      "Piping and plumbing BIM",
      "Electrical documentation",
      "Fire system design documentation",
      "4D BIM",
      "5D BIM",
      "6D BIM",
      "7D BIM",
      "Building simulations",
      "Change management",
      "Data management",
      "Lifecycle support",
      "Facility management support",
      "Construction documentation",
      "Authority approval documentation",
      "Design development support",
      "Quality-controlled project delivery"
    ],

    architecture: [
      "Project Brief & Design Input",
      "CAD Drafting",
      "BIM / Revit Modeling",
      "Architectural Documentation",
      "MEP Coordination",
      "Clash Detection",
      "3D Visualization",
      "Construction Documentation",
      "BIM Data & Lifecycle Support"
    ],

    screens: [
      gksImage1,
      gksImage2,
    ],

    results:
      "Established in 2010, GKS Studio has developed an international design documentation and BIM practice supporting architecture and interior design firms across multiple markets. The company states that its team has worked on projects in more than 20 countries, delivered more than 100 projects in architectural design, civil, structural and MEP engineering, and provides cost-effective outsourced documentation that can reduce production costs compared with in-house teams."
  }
},
  {
  slug: "gignaati",
  name: "Gignaati",
  category: "AI Ecosystem",
  industry: "AI Education & Workforce",
  description:
    "An integrated AI ecosystem that helps learners build practical AI skills, create and deploy AI agents, earn through verified AI gigs, and connect with global opportunities.",

  tech: [
    "React",
    "Next.js",
    "AI Agents",
    "LLMs",
    "n8n",
    "Ollama",
    "Docker",
    "Marketplace Platform"
  ],

  image:
    gignaatiImage1,

  caseStudy: {
    problem:
      "AI skills, practical AI development, and access to real earning opportunities were fragmented across separate platforms. Learners could study AI without gaining practical deployment experience, developers lacked an accessible environment for building AI agents, and businesses struggled to discover verified AI talent and ready-to-use AI solutions.",

    objectives: [
      "Create one connected ecosystem for AI learning, development, and earning",
      "Help learners move from AI education to practical implementation",
      "Provide a local AI development environment for building and deploying AI agents",
      "Connect verified AI professionals with businesses and global opportunities",
      "Create a structured pathway from learning to employability through the BADGE framework",
      "Enable creators to monetize AI agents, services, and expertise through the marketplace"
    ],

    solution:
      "Gignaati was designed as a connected AI workforce ecosystem combining three core experiences: the AI Academy for structured learning and certification, the AI Workbench for building and deploying AI agents, and the Marketplace for connecting certified AI talent with businesses and monetizing AI solutions. The ecosystem is supported by the 3E's Growth Journey—Education, Earning, and Employability—and the five-stage BADGE framework: Begin, Accredit, Develop, Gain, and Expand.",

    features: [
      "AI Academy with structured learning paths",
      "AI and machine-learning fundamentals",
      "Hands-on AI projects and practical labs",
      "Industry-recognized certifications and digital badges",
      "BADGE career-development framework",
      "AI Workbench for local agent development",
      "Docker-based AI environment setup",
      "n8n workflow automation",
      "Ollama and multiple LLM integrations",
      "Visual AI-agent development workflows",
      "Pre-built AI-agent templates",
      "Local testing and deployment",
      "Cloud deployment capabilities",
      "AI Gigs marketplace",
      "Verified AI talent discovery",
      "Freelancer project bidding and proposals",
      "AI gig publishing and monetization",
      "Employer project posting and hiring",
      "Ready-to-use AI agents and solutions",
      "Resource library with guides and templates",
      "Strategic partnership ecosystem",
      "AI workforce and employability programs",
      "Newsletter and AI opportunity updates"
    ],

    architecture: [
      "Gignaati Core Platform",
      "AI Academy",
      "AI Workbench",
      "AI Agent Infrastructure",
      "LLM & Automation Layer",
      "AI Gigs Marketplace",
      "Talent & Employer Network",
      "Certification & BADGE System",
      "Resources & Community",
      "Partnership Ecosystem"
    ],

    screens: [
      gignaatiImage1,
      gignaatiImage2,
    ],

    results:
      "Gignaati brings AI education, practical agent development, certification, workforce development, and AI gig opportunities into one connected ecosystem. The platform reports a reach of 900+ colleges and more than 1.2 million students, while its public ecosystem highlights 500+ success stories, presence across 50+ countries, and a growing network of AI professionals and businesses."
  }
}
];
